import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col } from 'reactstrap';
import ReactTableBase from '../../../../shared/components/table/ReactTableBase';

const ResizableReactTableWithoutPagination = ({ reactTableData, data, customClass }) => {
  const [isSortable, setIsSortable] = useState(false);
  const [isResizable, setIsResizable] = useState(true);
  const [withPagination, setWithPaginationTable] = useState(true);
  const [withSearchEngine, setWithSearchEngine] = useState(true);

  const handleClickIsSortable = () => {
    setIsSortable(!isSortable);
  };

  const handleClickWithPagination = () => {
    setWithPaginationTable(!withPagination);
  };

  const handleClickIsResizable = () => {
    setIsResizable(!isResizable);
  };

  const handleClickWithSearchEngine = () => {
    setWithSearchEngine(!withSearchEngine);
  };

  const tableConfig = {
    isEditable: false,
    isResizable: true,
    isSortable: true,
    withPagination,
    withSearchEngine,
    manualPageSize: [500, 1000, 1500, 2000],
    placeholder: 'Search by Title...',
  };

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody className={`${customClass} pl-0 pr-0`}>
          <ReactTableBase
            key={withSearchEngine ? 'searchable' : 'common'}
            columns={reactTableData.tableHeaderData}
            data={data}
            tableConfig={tableConfig}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

ResizableReactTableWithoutPagination.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  customClass: PropTypes.string,
};

ResizableReactTableWithoutPagination.defaultProps = {
  customClass: ''
}

export default ResizableReactTableWithoutPagination;
